import { TableRow, TableCell } from "@components/ui/table";
import { useFormatSubscribers } from "@/hooks/useFormatSubscribers";
import { useLingui } from "@lingui/react/macro";
import { User } from "@/types/User";
import { ReportListItem } from "@/types/Report";
import { ReportSubscription } from "@/types/ReportSubscription";
import { Switch } from "@components/ui/switch";
import { useDelayedLoading } from "@/hooks/useDelayedLoading";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Organization } from "@/types/Organization";

type ReportRowProps = {
  onDeleteAlertSubscription: (id: ReportSubscription["id"]) => void;
  reportSubscriptions: ReportSubscription[];
  onCreateAlertSubscription: () => void;
  isCreatingReportSubscription: boolean;
  isDeletingReportSubscription: boolean;
  isShowingSubscribers?: boolean;
  orgUuid: Organization["uuid"];
  report: ReportListItem;
  userId: User["id"];
};

export default function ReportRow({
  isCreatingReportSubscription,
  isDeletingReportSubscription,
  isShowingSubscribers = true,
  onCreateAlertSubscription,
  onDeleteAlertSubscription,
  reportSubscriptions,
  orgUuid,
  userId,
  report,
}: ReportRowProps) {
  const { t } = useLingui();

  // Helpers
  const formatSubscribers = useFormatSubscribers();

  const reportSubscription = reportSubscriptions.find(
    (rs) => rs.uuid === report.uuid
  );

  const { isVisible: isLoading } = useDelayedLoading(
    isCreatingReportSubscription || isDeletingReportSubscription,
    300
  );

  return (
    <TableRow>
      <TableCell className="font-medium truncate">
        <Link
          to={generatePath(ROUTES.REPORTS_EDIT_ORGID, {
            orgUuid,
            uuid: report.uuid,
          })}
          className="link"
        >
          {report.title || t`Blank rapport`}
        </Link>
      </TableCell>

      <TableCell>
        <Switch
          disabled={isLoading}
          checked={!!reportSubscription}
          onCheckedChange={(checked) => {
            if (checked) {
              onCreateAlertSubscription();
            } else if (reportSubscription) {
              onDeleteAlertSubscription(reportSubscription.id);
            }
          }}
        />
      </TableCell>

      {isShowingSubscribers && (
        <TableCell>{formatSubscribers(report.subscribers, userId)}</TableCell>
      )}
    </TableRow>
  );
}
